import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";
const FeeTyoe = "/api/business/feeType";
const LicNumberCCDV = "/api/business/company-lic-number";

export default class AdministrativeSanctions {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllDispatch(querySearch, cancelToken?): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/xphc/search", querySearch, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getDetailSanctions(receipt_id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/xphc/${receipt_id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // public getAllCompanies(querySearch?: any): Promise<any> {
  //   return new Promise<any>((resolve, reject) => {
  //     axios
  //       .post("/api/business/company?page=0&size=10000", querySearch)
  //       .then((res) => {
  //         resolve(res.data);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // }

  public getAllCompanies(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/companyList`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public updateDispatch(receipt_id, query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`/api/business/xphc/${receipt_id}`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public deleteSanctions(query): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`/api/business/xphc/${query}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public createSanctions(queryForm: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/xphc", queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getSanctions(queryForm: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/xphc`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // public UploadFile(file): Promise<any> {
  //   return new Promise<any>((resolve, reject) => {
  //     axios
  //       .post(baseUrl + `/api/file/upload`, file)
  //       .then((res) => {
  //         resolve(res.data);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // }

  public getTextNumber(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/xphc/numbers`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public AllFeetype(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(FeeTyoe, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public excelSanctions(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/xphc/excel", querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
}
